import { AccountInterface } from 'client/Interfaces/AccountsInterface'

import * as api from '../api/accounts'
import { actionCreatorAsync, AsyncAction } from './index'

export function getAccounts(existingAccounts?: AccountInterface[]): AsyncAction<AccountInterface[]> {
  return actionCreatorAsync<AccountInterface[]>('GET_ACCOUNTS', async () => {
    return existingAccounts ? Promise.resolve(existingAccounts) : await api.getAccounts()
  })
}
